<template>
    <!-- 喵喵个人账号页面 -->
  <div id="account">
    <login-or-register-vue/>
  </div>
</template>

<script>
import LoginOrRegisterVue from '@/components/account/LoginOrRegister.vue';
import { mapState } from 'vuex';
export default {
    name:'AccountView',
    components:{
      LoginOrRegisterVue
    },
    data(){
      return{

      }
    },
    computed:{
      ...mapState('account',['accountInfo'])
    },
    mounted(){
      console.log(this.accountInfo)
    }
}
</script>

<style lang="less" scoped>
#account{
    
}
</style>